const data = (response) => response?.data ?? response ?? {}
const array = (value) => Array.isArray(value) ? value : []
const count = (value) => Number.isFinite(value) ? value : 0

export class MemberTypeCorrectionStep {
  constructor(value = {}) {
    this.stepKey = value.stepKey || ''
    this.status = value.status || ''
    this.appliedAt = value.appliedAt || null
    this.appliedBy = value.appliedBy || null
    this.changedCount = count(value.changedCount)
    this.excludedCount = count(value.excludedCount)
    this.conflictCount = count(value.conflictCount)
  }
}

export class MemberTypeCorrectionRun {
  constructor(value = {}) {
    this.runId = value.runId ?? null
    this.billingYear = value.billingYear ?? null
    this.asOfDate = value.asOfDate || null
    this.status = value.status || ''
    this.currentStep = value.currentStep || null
    this.steps = array(value.steps).map((step) => new MemberTypeCorrectionStep(step))
  }
}

export class MemberTypeCorrectionCandidate {
  constructor(value = {}) {
    this.memberId = value.memberId ?? null
    this.firstName = value.firstName || ''
    this.lastName = value.lastName || ''
    this.birthDate = value.birthDate || null
    this.ageAtAsOfDate = value.ageAtAsOfDate ?? null
    this.currentMemberType = value.currentMemberType || ''
    this.newMemberType = value.newMemberType || ''
    this.membershipRole = value.membershipRole || 'UNKNOWN'
    this.memberGroupId = value.memberGroupId ?? null
    this.memberGroupDisplayName = value.memberGroupDisplayName || null
    this.reason = value.reason || ''
    this.warning = value.warning || null
    this.selected = value.currentMemberType !== 'VEREIN'
  }
}

export class MemberTypeCorrectionWarning {
  constructor(value = {}) {
    this.memberId = value.memberId ?? null
    this.memberGroupId = value.memberGroupId ?? null
    this.firstName = value.firstName || null
    this.lastName = value.lastName || null
    this.warning = value.warning || ''
  }
}

export class MemberTypeCorrectionPreview {
  constructor(value = {}) {
    this.runId = value.runId ?? null
    this.stepKey = value.stepKey || ''
    this.billingYear = value.billingYear ?? null
    this.asOfDate = value.asOfDate || null
    this.candidates = array(value.candidates).map((candidate) => new MemberTypeCorrectionCandidate(candidate))
    this.warnings = array(value.warnings).map((warning) => new MemberTypeCorrectionWarning(warning))
  }
}

export class MemberTypeCorrectionConflict {
  constructor(value = {}) {
    Object.assign(this, {
      memberId: value.memberId ?? null,
      firstName: value.firstName || null,
      lastName: value.lastName || null,
      expectedMemberType: value.expectedMemberType || null,
      actualMemberType: value.actualMemberType || null,
      message: value.message || ''
    })
  }
}

export class MemberTypeCorrectionApplyResult {
  constructor(value = {}) {
    this.runId = value.runId ?? null
    this.stepKey = value.stepKey || ''
    this.status = value.status || ''
    this.changedCount = count(value.changedCount)
    this.excludedCount = count(value.excludedCount)
    this.conflictCount = count(value.conflictCount)
    this.conflicts = array(value.conflicts).map((conflict) => new MemberTypeCorrectionConflict(conflict))
    this.nextStep = value.nextStep || null
    this.runStatus = value.runStatus || ''
  }
}

export class MemberTypeCorrectionSummary {
  constructor(value = {}) {
    this.runId = value.runId ?? null
    this.billingYear = value.billingYear ?? null
    this.asOfDate = value.asOfDate || null
    this.status = value.status || ''
    this.changedCount = count(value.changedCount)
    this.excludedCount = count(value.excludedCount)
    this.conflictCount = count(value.conflictCount)
    this.skippedStepCount = count(value.skippedStepCount)
    this.steps = array(value.steps).map((step) => new MemberTypeCorrectionStep(step))
  }
}

export const adaptRun = (response) => new MemberTypeCorrectionRun(data(response))
export const adaptPreview = (response) => new MemberTypeCorrectionPreview(data(response))
export const adaptApplyResult = (response) => new MemberTypeCorrectionApplyResult(data(response))
export const adaptSummary = (response) => new MemberTypeCorrectionSummary(data(response))
